<template>
  <div>
    <v-layout row>
      <v-flex xs12>
        <v-toolbar dense flat>
          <v-text-field
            v-model="search"
            prepend-icon="search"
            label="Search"
            single-line
            hide-details
            style="padding:0;"
          ></v-text-field>
        </v-toolbar>
      </v-flex>
    </v-layout>
    <v-data-table
      :search="search"
      :headers="headers"
      :loading="loading_message"
      :items="product_edit_store_list"
      :pagination.sync="pagination"
    >
      <template slot="items" slot-scope="props">
        <td class="text-xs-center">{{ props.index + 1 }}</td>
        <td class="text-xs-center">{{ props.item.store_name_th }}</td>
        <td class="text-xs-center">{{ props.item.store_name_en }}</td>
        <td class="text-xs-center">{{ props.item.product_count}}</td>
        <td class="justify-center px-0">
          <v-tooltip top>
            <v-btn
              icon
              slot="activator"
              :disabled="fetching_data"
              :loading="fetching_data"
              @click="toView(props.item)"
            >
              <v-icon small>remove_red_eye</v-icon>
            </v-btn>
            <span>View</span>
          </v-tooltip>
        </td>
      </template>

      <template slot="no-data">
        <div v-if="loading_message == false">
          No data available
          <br />
          <v-btn icon @click="initStore()">
            <v-icon>refresh</v-icon>
          </v-btn>
        </div>
        <div v-else>
          <v-progress-circular :size="30" color="primary" indeterminate></v-progress-circular>
          {{ 'Loading data ...' }}
        </div>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  props: ["loading_message"],
  data() {
    return {
      fetching_data: false,
      search: "",
      store_code: "",
      store_name_th: "",
      amount_product_approve: "",
      pagination: {
        rowsPerPage: 10,
        page: 1,
        totalItems: 0,
      },
      headers: [
        {
          text: "No ",
          align: "center",
          sortable: false,
          value: "store_code",
        },
        {
          text: "Store Name TH ",
          align: "center",
          value: "store_name_th",
          sortable: false,
        },
        {
          text: "Store Name EN",
          align: "center",
          value: "store_name_en",
          sortable: false,
        },
        {
          text: "Amount Product",
          align: "center",
          value: "store_product_count",
          sortable: false,
        },
        {
          text: "View product",
          align: "center",
          value: "View product",
          sortable: false,
        },
      ],
    };
  },
  computed: {
    ...mapState({
      product_edit_store_list: (state) =>
        state.fetchProductApproveBack.product_edit_store_list,
    }),
    pages() {
      this.pagination.totalItems = this.product_edit_store_list.length;
      if (
        this.pagination.rowsPerPage == null ||
        this.pagination.totalItems == null
      )
        return 0;

      return Math.ceil(
        this.pagination.totalItems / this.pagination.rowsPerPage
      );
    },
  },
  methods: {
    initStore() {
      this.$emit("initStore");
    },
    async toView(item) {
      this.$store.commit(
        "fetchProductApproveBack/setProductEditList",
        item.product
      );
      this.$emit("setComponentID", "productApproveTable");
      this.$emit("setStoreName", item.store_name_th);
    },
  },
  created() {},
};
</script>

<style scoped>
</style>